import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useAppTheme, useThemeHelpers } from '../../hooks/useAppTheme.js';
import '../../styles/teacherOnboarding.big-top.scss';

const STATUS_COPY = {
  success: {
    variant: 'success',
    title: 'School email verified',
    body: 'Thank you! Your school email is verified. Your teacher access request remains pending review.',
  },
  'already-verified': {
    variant: 'info',
    title: 'School email already verified',
    body: 'This school email address was already verified. No further action is needed.',
  },
  expired: {
    variant: 'warning',
    title: 'Verification link expired',
    body: 'This verification link has expired. Sign in and resend verification from your profile.',
  },
  invalid: {
    variant: 'danger',
    title: 'Invalid verification link',
    body: 'This verification link is invalid or has already been used. Sign in and resend verification from your profile if needed.',
  },
};

export default function TeacherEmailVerified() {
  const [searchParams] = useSearchParams();
  const theme = useAppTheme();
  const { isThemed, pageClass } = useThemeHelpers(theme);
  const pageThemeClass = pageClass('teacherOnboarding');
  const shellClass = pageThemeClass ? `teacher-onboarding ${pageThemeClass}` : 'teacher-onboarding';

  const status = searchParams.get('status') || 'invalid';
  const copy = STATUS_COPY[status] || STATUS_COPY.invalid;

  return (
    <div className={shellClass}>
      <div className="teacher-onboarding__card">
        <h1 className="teacher-onboarding__title">{copy.title}</h1>
        <Alert variant={copy.variant}>{copy.body}</Alert>
        <div className="teacher-onboarding__actions">
          <Button as={Link} to="/viewProfile" variant="primary">
            Go to profile
          </Button>
          <Button as={Link} to="/sectionHome" variant="outline-secondary">
            Continue to app
          </Button>
        </div>
      </div>
    </div>
  );
}
